/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PendingReferralViewModel } from './PendingReferralViewModel'; 

export function getPendingReferralOptions(id: string, onSuccess?: (result: PendingReferralViewModel) => void) {
	return queryOptions({
		queryKey: ['pending-referral', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/intake/pendingreferrals/queries/getpendingreferral/' + id;
			const resp = await axios.get<PendingReferralViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}